/* global module require */
const lib = require('./tv_base.js');
lib.artwork = require('../tv_artwork/tv_artwork.ts');
lib.configurator = require('../tv_configurator/init_product.ts');
lib.configurator_v2 = require('../tv_configurator_v2/init_product.ts');
lib.faq_schema = require('../tv_faq_schema/faq_schema.ts');
lib.faq_section = require('../tv_utils/faq_section.ts');
lib.g_recaptcha = require('../tv_third_party_integrations/g_recaptcha.ts');
lib.products = require('../tv_products/products.ts');
lib.product_quotes = require('../tv_product_quotes/product_quotes.ts');
lib.product_videos = require('../tv_products_videos/thumbnail.ts');
lib.sticky_block = require('../tv_utils/sticky_block.ts');
lib.yotpo = require('../tv_third_party_integrations/yotpo.ts');
module.exports = lib;
